import * as CartService from '../services/CartService'

export const REMOVE_PARTICIPANT_FROM_ITEM_REQUEST = 'REMOVE_PARTICIPANT_FROM_ITEM_REQUEST';
export const REMOVE_PARTICIPANT_FROM_ITEM_SUCCESS = 'REMOVE_PARTICIPANT_FROM_ITEM_SUCCESS';
export const REMOVE_PARTICIPANT_FROM_ITEM_FAILURE = 'REMOVE_PARTICIPANT_FROM_ITEM_FAILURE';

export function removeParticipantFromItemRequest(itemIdentifier, identifier) {
    return {
        type: REMOVE_PARTICIPANT_FROM_ITEM_REQUEST,
        itemIdentifier,
        identifier
    }
}

export function removeParticipantFromItemSuccess(payload) {
    return {
        type: REMOVE_PARTICIPANT_FROM_ITEM_SUCCESS,
        payload
    }
}

export function removeParticipantFromItemFailure(payload) {
    return {
        type: REMOVE_PARTICIPANT_FROM_ITEM_FAILURE,
        payload
    }
}

export function removeParticipantFromItem(itemIdentifier, identifier) {
    return (dispatch) => {
        dispatch(removeParticipantFromItemRequest(itemIdentifier, identifier));

        CartService.removeParticipantFromItem(itemIdentifier, identifier)
            .then(response => {
                dispatch(removeParticipantFromItemSuccess(response));
            })
            .catch(error => {
                dispatch(removeParticipantFromItemFailure(error));
            });
    }
}
